import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeBracket'
})
export class RemoveBracketPipe implements PipeTransform {

  transform(input: string): string {
    const text = input ? input.replace(/\(.*\)/g, '') : '';
    return text.trim();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/remove-bracket.pipe.ts